// Skeleton Components
const SkeletonInput = ({ labelWidth = "120px", className = "" }) => (
  <div className={`skeleton-input ${className}`}>
    <div
      className="skeleton-label mb-2"
      style={{
        width: labelWidth,
        height: "16px",
        background: "#f0f0f0",
        borderRadius: "4px",
      }}
    ></div>
    <div
      className="skeleton-field"
      style={{
        width: "100%",
        height: "40px",
        background: "#f0f0f0",
        borderRadius: "6px",
      }}
    ></div>
  </div>
);

const SkeletonAddressAutocomplete = ({
  labelWidth = "140px",
  className = "",
}) => (
  <div className={`skeleton-input ${className}`}>
    <div
      className="skeleton-label mb-2"
      style={{
        width: labelWidth,
        height: "16px",
        background: "#f0f0f0",
        borderRadius: "4px",
      }}
    ></div>
    <div
      className="skeleton-field"
      style={{
        width: "100%",
        height: "55px",
        background: "#f0f0f0",
        borderRadius: "6px",
      }}
    ></div>
  </div>
);

const AddRouteScheduleSkeleton = () => {
  return (
    <div className="form-skeleton">
      {/* Form Inputs Skeleton */}
      <div className="row mb-4">
        {/* Route Name */}
        <div className="col-12 col-md-6 mb-3">
          <SkeletonInput labelWidth="130px" />
        </div>

        {/* Radius */}
        <div className="col-12 col-md-6 mb-3">
          <SkeletonInput labelWidth="130px" />
        </div>

        {/* Pickup Address */}
        <div className="col-12 mb-3">
          <SkeletonAddressAutocomplete labelWidth="130px" />
        </div>

        {/* Dropoff Address */}
        <div className="col-12 mb-4">
          <SkeletonAddressAutocomplete labelWidth="130px" />
        </div>
      </div>

      {/* Button Skeleton */}
      <div className="pt-4 mt-3 border-top text-end">
        <div
          className="skeleton-button d-inline-block me-3"
          style={{
            width: "100px",
            height: "40px",
            background: "#f0f0f0",
            borderRadius: "4px",
          }}
        ></div>
        <div
          className="skeleton-button d-inline-block"
          style={{
            width: "100px",
            height: "40px",
            background: "#f0f0f0",
            borderRadius: "4px",
          }}
        ></div>
      </div>
    </div>
  );
};

export default AddRouteScheduleSkeleton;
